import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const Button = ({ to, href, variant = 'primary', className = '', children, ...props }) => {
  const base = 'inline-flex items-center justify-center rounded-full px-6 py-3 text-sm font-semibold transition duration-300 focus:outline-none focus:ring-2 focus:ring-primary/40';
  const styles =
    variant === 'secondary'
      ? 'bg-white/10 text-white border border-white/10 hover:bg-white/15'
      : 'bg-primary text-slate-950 hover:bg-primaryLight hover:shadow-[0_0_20px_rgba(201,162,74,0.6)]';

  const Component = to ? Link : 'a';

  return (
    <motion.div whileHover={{ y: -2 }} whileTap={{ scale: 0.98 }} className={className}>
      <Component to={to} href={href} className={`${base} ${styles}`} {...props}>
        {children}
      </Component>
    </motion.div>
  );
};

export default Button;
